import React from "react";
import PropTypes from "prop-types";
import { SelectButton } from "primereact/selectbutton";
import { getTaskTypeOptions } from "./Utils";

export default function ActionFilter({
  className = "",
  type,
  taskType,
  setTaskType,
  itemsToCount = [],
}) {
  const TypeOptions = getTaskTypeOptions(type, itemsToCount);
  // console.log('ActionFilter.render() type:', type, "taskType:", taskType, TypeOptions);
  return (
    <div className={className}>
      <SelectButton
        id="action-filter"
        data-test-id="action-filter"
        className="action-filter"
        options={TypeOptions}
        value={taskType}
        onChange={(event) => setTaskType && setTaskType(event.value)}
      />
    </div>
  );
}

ActionFilter.propTypes = {
  className: PropTypes.string,
  taskType: PropTypes.string,
  type: PropTypes.string,
  setTaskType: PropTypes.func,
  itemsToCount: PropTypes.array,
};
